import { IColumnFormat } from './column-format.model';
import { FormatType } from './format-type.model';

export class ColumnFormatNumber implements IColumnFormat {
    digitInfo: string;
    formatType: string = FormatType[FormatType.Number];
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/column-format-number.model.ts